import React, { useState, useEffect, useRef } from "react";
import 'bootstrap/dist/js/bootstrap.min.js';
import { useDispatch, useSelector } from 'react-redux'
import {
  Row,
  Container,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import BreadCrumb from "../../Components/Common/BreadCrumb";
import FormControl from '@mui/material/FormControl';
import { Role } from "../../constants/Role";
import { BoardName } from "../../constants/Board";
import { AllStatusList } from "../../api/casp/status";
import { getUserList } from "../../api/casp/user";
import { AllPriorityList } from "../../api/casp/priority";
import { getTicketList, updateTicketStatus } from "../../api/casp/ticket";
import { PerPage } from "../../constants/Common";
import { toast } from "react-toastify";
import Tooltipp from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import { useParams } from "react-router-dom";
import PriorityIcon from "../../Components/Icon/priority";
import SearchDropDownListPaginationComponent from "../../Components/casp/common/SearchDropDownPaginationList";
import Cogs from "../../assets/images/icons/jam_cog-f.svg";
import InfiniteScroll from "react-infinite-scroll-component";
import Loader from "../../Components/Common/Loader";
import { TicketStatuses } from "../../constants/Status";
import _ from "lodash";
import { Helmet } from 'react-helmet';
import { getIconPath } from "../../helpers/file_helper";
import { filter } from 'lodash/collection'
import { get } from 'lodash/object'
import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined';
import UserProfile from "../../Components/casp/common/userProfile";
import { withTranslation } from "react-i18next";

const Board = (props) => {
  const dispatch = useDispatch()
  const navigate = useNavigate();
  const { project } = useParams();
  const loggedInUser = useSelector((state) => state.Profile.user)
  const [draggableKey, setDraggableKey] = useState(+new Date())
  const [statusList, setStatusList] = useState([])
  const [assigneeList, setAssigneeList] = useState([])
  const [projectParams, setProjectParams] = useState({})
  const initialPage = 1;
  const [page, setPage] = useState(initialPage);
  const [isLoading, setIsLoading] = useState(false)
  const location = useLocation();
  const [boardData, setboardData] = useState({});

  useEffect(() => {
    setProjectParameter()
    getStatusList()
    getAssigneeList()
  }, [dispatch]);

  const setProjectParameter = () => {
    try {
      const params = {
        order: "updatedAt",
        direction: "desc"
      }
      if (![Role.EPMO_MANAGER, Role.ROOT_ADMIN, Role.VICE_PRESIDENT, Role.PRESIDENT, Role.PROGRAM_MANAGER, Role.EPMO_OFFICER].includes(loggedInUser?.role?.name)) {
        params.userId = loggedInUser.id
      }

      setProjectParams(params)
    } catch (error) {
      console.log(error)
    }
  }

  const getStatusList = async () => {
    try {
      const statusApiParams = {
        projectId: parseInt(project),
        filterFields: ['board'],
        filterInputs: [BoardName.KANBAN],
        excludeFilterFields: ['name'],
        excludeFilterInputs: [TicketStatuses.DRAFT]
      }
      const res = await AllStatusList(statusApiParams);
      if (res.data.data.data.length > 0) {
        let statuses = res.data.data.data
        setStatusList(statuses)
        arrangeTicketsByStatus(statuses);
      }
    } catch (error) {
      console.log(error);
    }
  }

  const getAssigneeList = async () => {
    try {
      const userListApiParams = {
        filterFields: ['role'],
        filterInputs: [Role.MEMBER]
      }
      const res = (await getUserList(userListApiParams)).data.data.data

      if (res.length > 0) {
        let userLists = res.map((user) => {
          return {
            id: user.id,
            name: user.name
          }
        })
        setAssigneeList(userLists)
      }

    } catch (error) {
      console.log(error)
    }
  }

  const onDragEnd = (result) => {

    if (!result.destination) return;
    const { source, destination } = result;
    if (source.droppableId !== destination.droppableId) {
      const sourceColumn = boardData[source.droppableId];
      const destColumn = boardData[destination.droppableId];
      const sourceItems = [...sourceColumn.history];
      const destItems = [...destColumn.history];
      const [removed] = sourceItems.splice(source.index, 1);
      destItems.splice(destination.index, 0, removed);
      sourceColumn.no_ofissue = sourceColumn.no_ofissue - 1;
      destColumn.no_ofissue = destColumn.no_ofissue + 1;
      setboardData({
        ...boardData,
        [source.droppableId]: {
          ...sourceColumn,
          history: sourceItems
        },
        [destination.droppableId]: {
          ...destColumn,
          history: destItems
        }
      });
      changeTicketStatus(removed.id, destColumn.id, removed.projectId);
    } else {
      const column = boardData[source.droppableId];
      const copiedItems = [...column.history];
      const [removed] = copiedItems.splice(source.index, 1);
      copiedItems.splice(destination.index, 0, removed);
      setboardData({
        ...boardData,
        [source.droppableId]: {
          ...column,
          history: copiedItems
        }
      });
    }
  };

  const changeTicketStatus = async (ticketId, statusId, projectId) => {
    try {
      const response = await updateTicketStatus({ ticketId, statusId }, { projectId: projectId });
      if (response.statusCode === 200) {
        toast.success(response.data.message);
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      toast.error(error.message)
    }
  }


  // Organize all tickets group by status required for kanban view
  const arrangeTicketsByStatus = async (statuses) => {
    let allTickets = {};
    try {
      const tempStatuses = []
      for (let index = 0; index < statuses.length; index++) {
        const ticketsOfSpecificStatus = await fetchProjectTicketsByStatus(statuses[index].name);
        Object.assign(allTickets, {
          [index + 1]: {
            id: statuses[index].id,
            name: (statuses[index].name).toUpperCase(),
            hasMore: ticketsOfSpecificStatus.tickets.length ? true : false,
            page: 2,
            no_ofissue: ticketsOfSpecificStatus.meta.total,
            history: ticketsOfSpecificStatus.tickets
          }
        })
        if (ticketsOfSpecificStatus.meta?.next) {
          tempStatuses.push(statuses[index]);
        }

      }

      if (tempStatuses.length > 0) {
        setPage(page => page + 1);
      }
      setboardData(allTickets);
    } catch (error) {
      console.error(error)
    }
  }
  // Fetch all project tickets group by status
  const fetchProjectTicketsByStatus = async (status, currentPage) => {
    try {
      const params = {
        filterInputs: status,
        filterFields: "status",
        ...((assignTo !== '' && assignTo !== 'All Assignees') && {
          filterInputs: [status, assignTo.toString()],
          filterFields: ["status", "assignee"]
        }),
        ...((priority !== '') && {
          filterInputs: [status, priority],
          filterFields: ["status", "priority"]
        }),
        ...((priority !== '' && (assignTo !== '' && assignTo !== 'All Assignees')) && {
          filterInputs: [status, assignTo.toString(), priority],
          filterFields: ["status", "assignee", "priority"]
        }),
        ...((isNaN(parseInt(project))) ? undefined : { projectId: parseInt(project) }),
        order: 'updatedAt',
        direction: 'asc',
        perPage: PerPage[0],
        page: currentPage ? currentPage : page,
      }

      const res = (await getTicketList(params)).data.data;
      const result = res.data.map((ticket) => ({
        id: ticket.id,
        statusId: ticket.status.id,
        name: ticket.name,
        type: ticket.ticketType.name,
        priority: ticket.priority,
        projectId: ticket.project.id,
        assignee: ticket.assignee ? ticket.assignee.name : null,
        user: ticket.assignee,
      }));
      return {
        tickets: result,
        meta: res.meta
      }
    } catch (error) {
      return {
        tickets: [],
        meta: {
          next: null
        }
      }
    }
  }
  const handleInfiniteScollForEachStatus = async (statusName, _statusId) => {
    setIsLoading(true)
    const boardIndex = (statusList.findIndex(i => i.name === statusName.toLowerCase()) + 1);
    const ticketsOfSpecificStatus = await fetchProjectTicketsByStatus(statusName.toLowerCase(), boardData[boardIndex].page)
    if (ticketsOfSpecificStatus.tickets.length > 0) {
      const column = boardData[boardIndex];
      const tempPageNo = boardData[boardIndex].page + 1
      const totalHistory = [...column.history, ...ticketsOfSpecificStatus.tickets];
      setboardData((boardData) => ({
        ...boardData,
        [boardIndex]: {
          ...column,
          history: totalHistory,
          hasMore: true,
          page: tempPageNo
        }
      }));
    } else {
      boardData[boardIndex].hasMore = false
    }
    setIsLoading(false)
  }

  useEffect(() => {
    setDraggableKey(+new Date())
  }, [boardData])

  const getItemStyle = (isDragging, draggableStyle) => ({

    ...draggableStyle
  });


  // Assign To dropdown starts
  const [assignTo, setAssignTo] = useState('');

  const [priority, setPriority] = useState('');

  // detect change of assignTo and priority and call the function
  useEffect(() => {
    arrangeTicketsByStatus(statusList)
  }, [assignTo, priority])

  // Copy to clipboard
  const copyContent = async (ticketId, projectId) => {
    try {
      const linkUrl = window.location.origin + `/project/${projectId}/ticket/${ticketId}`
      await navigator.clipboard.writeText(linkUrl);
      toast.success("Link copied.")
    } catch (err) {
      toast.error('Failed to copy.');
    }
  }

  const getListStyle = isDraggingOver => ({
    background: 'rgba(130, 130, 130, 0.07)',
    height: '100%',
    marginRight: '15px',
    borderRadius: '6px'
  })

  return (
    <React.Fragment>
      <div className="page-content position-relative">
      <Helmet
          onChangeClientState={(newState, addedTags) => {
            try {
            // Check if we added any new link[rel="icon"] elements.
            const newFaviconElems = filter(get(newState, 'linkTags', []), {
                rel: 'icon',
            })
  
            if (!newFaviconElems.length) {
                return
            }
        
            // Get the href of the last link element we just added, which
            // we assume is the most recently-added favicon.
            const newFaviconHref =
                newFaviconElems[newFaviconElems.length - 1].href
        
            // Remove all react-helmet link elements with rel="icon" that
            // do not have the href of our recently-added favicon.
            // If no other favicon elements exist, we don't have to do
            // anything.
            const existingFavicons = document.querySelectorAll(
                `link[rel="icon"][data-react-helmet]:not([href="${newFaviconHref}"])`
            )
  
            if (existingFavicons.length) {
                existingFavicons.forEach(e => e.parentNode.removeChild(e))
            }
        
            // Remove and re-add the latest link element to make sure
            // the browser uses it.
            const newFaviconElem = document.querySelector(
                `link[rel="icon"][data-react-helmet][href="${newFaviconHref}"]`
            )
  
            if (newFaviconElem) {
                const newFavElement = newFaviconElem.cloneNode(true)
                newFavElement.href = `data:image/svg+xml,${encodeURIComponent(
                    `<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>${getIconPath(<DashboardOutlinedIcon />)}</svg>`
                  )}`
                const parentElem = newFaviconElem.parentNode
                parentElem.removeChild(newFaviconElem)
                parentElem.appendChild(newFavElement)
            }
            } catch (e) {
            console.error(e)
            }
        }}
      >
            {/* Set the favicon using a data URI */}
          <title>{props.t("Project Kanban Board")}</title>
            {/* <link
            rel="icon"
            type="image/x-icon"
            href={`data:image/svg+xml,${encodeURIComponent(
                `<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'><path d='${getIconPath(<SettingsOutlinedIcon />)}'/></svg>`
              )}`}
            /> */}
      </Helmet>
        <Container fluid>
          {/* BreadCrumb area starts */}
          <div className="mainPageHeader d-flex justify-content-between">
            <BreadCrumb title={props.t("All Startup")} />
            <div className="kanbanFilters d-flex">
              <div className="filterTitle d-flex align-items-center">
                <i className="ri-filter-2-fill"></i>
                <p className="mb-0 mx-1"> {props.t("Filter by")} </p>
              </div>


              {/* All AssignedTo dropdown starts */}
              <FormControl sx={{ m: 1, minWidth: 160 }}>
                <SearchDropDownListPaginationComponent
                  label={props.t("Assign To")}
                  searchEnabled={true}
                  listCall={getUserList}
                  emitItem={(newValue) => {
                    if (newValue !== null && newValue !== undefined) {
                      setAssignTo(newValue.id)
                    }
                    else {
                      setAssignTo('')
                    }
                    setPage(1)
                  }}
                  apiParams={{
                    filterFields: ["projectUser"],
                    filterInputs: [project],
                  }}
                />
              </FormControl>
              {/* All AssignedTo dropdown ends */}

              {/* All Priority dropdown starts */}
              <FormControl sx={{ m: 1, minWidth: 160 }}>
                <SearchDropDownListPaginationComponent
                  label={props.t("Priority")}
                  searchEnabled={true}
                  listCall={AllPriorityList}
                  emitItem={(newValue) => {
                    if (newValue !== null && newValue !== undefined) {
                      setPriority(newValue.name)
                    }
                    else {
                      setPriority('')
                    }
                    setPage(1)
                  }}
                />
              </FormControl>
              {/* All AssignedTo dropdown ends */}

            </div>
          </div>
          <div className="kanban_board mt-4 d-flex justify-content-start align-items-start w-100">
            {/* <Row> */}

            <DragDropContext onDragEnd={onDragEnd}>
              {Object.entries(boardData).map(([columnId, column], index) => {
                const newKey = 'Status Column' + (columnId).toString()
                return (
                  <Droppable key={newKey} droppableId={columnId} >
                    {(provided, snapshot) => (
                      <div
                        ref={provided.innerRef}
                        style={getListStyle(snapshot.isDraggingOver)}
                        {...provided.droppableProps}
                      >
                        <div className="kanban_board_status">
                          <div className="kanban_board_title">
                            <div className="header d-flex justify-content-between align-items-baseline px-2">
                              <span className="heading_title mt-2 mb-2">
                                {props.t(column.name)}
                              </span>
                              <span className="count">{column.no_ofissue} {props.t('issue')}</span>
                            </div>
                              <InfiniteScroll
                                key={column.id}
                                dataLength={column.history.length}
                                hasMore={boardData[columnId].hasMore}
                                next={() => {
                                  if (!isLoading && boardData[columnId].hasMore) {
                                    handleInfiniteScollForEachStatus(column.name, column.id);
                                  }
                                }}
                                height={'655px'}
                                loader={isLoading && <Loader />}
                                //scrollableTarget={`scrollable-status-column-${columnId}`}
                              >
                                {column.history.map((it, ind) => {
                                  return (
                                    <Draggable
                                      key={`${ind}-${draggableKey}`}
                                      draggableId={it.id.toString()}
                                      index={ind}
                                    >
                                      {(provided, snapshot) => (
                                        <div className="tickets"

                                          {...provided.draggableProps}
                                          {...provided.dragHandleProps}
                                          ref={provided.innerRef}
                                          style={getItemStyle(
                                            snapshot.isDragging,
                                            provided.draggableProps.style
                                          )}
                                        >
                                          <div className="ticket_card p-3">
                                            <div className="d-flex justify-content-between align-items-center p-1">
                                              <h6
                                                className="ticket_name"
                                                style={{ cursor: "pointer" }}
                                                onClick={() => navigate(`/project/${it.projectId}/ticket/${it.id}`, { from: location.pathname })}
                                              >
                                                {it.name}
                                              </h6>
                                          {/* <div className="boardThreeDots d-flex justify-content-end">
                                                <ul className="ps-0">
                                                  <li className="list-inline-item dropdown">
                                                    <UncontrolledDropdown>
                                                      <DropdownToggle
                                                        tag="a"
                                                        className="dot_color"
                                                      >
                                                        <i
                                                          role="button"
                                                          style={{ fontSize: "18px" }}
                                                        >
                                                          <MoreVertIcon />
                                                        </i>
                                                      </DropdownToggle>

                                                      <DropdownMenu className="dropdown-menu-end">
                                                        <DropdownItem>Edit</DropdownItem>

                                                        <DropdownItem>Delete</DropdownItem>
                                                      </DropdownMenu>
                                                    </UncontrolledDropdown>
                                                  </li>
                                                </ul>
                                              </div>  */}

                                            </div>
                                            <div className="ticket_number">
                                              <div className="icon d-flex align-items-end">
                                                <OverlayTrigger
                                                  key={`${it.id} Ticket Copy Link`}
                                                  placement="bottom"
                                                  overlay={<Tooltipp className="mytooltip">{props.t('Copy issue link')}</Tooltipp>}
                                                >
                                                  <div className="ticket_number_block mb-0" style={{ cursor: "pointer" }} onClick={(e) => { copyContent(it.id, it.projectId) }}>
                                                    <div className="d-flex">
                                                      <img src={Cogs} alt={Cogs} />
                                                      {/* <OverlayTrigger
                                                      key={`${it.id} Ticket Type`}
                                                      placement="bottom"
                                                      overlay={<Tooltipp className="mytooltip">Issue Type</Tooltipp>}
                                                    >
                                                      <span className="badge bg-info rounded">{it.type}</span>
                                                    </OverlayTrigger> */}
                                                      <div className="ticketNo ms-1">#CASP-{it.id}</div>
                                                    </div>
                                                  </div>
                                                </OverlayTrigger>
                                              </div>
                                            </div>
                                            <div className="ticket_footer mt-2">
                                              <div className="d-flex justify-content-between">
                                                <div className="MuiAvatarGroup-root css-1mceequ">
                                                  {
                                                    (it.assignee !== undefined && it.assignee !== null) &&
                                                    (
                                                      <OverlayTrigger
                                                        placement="bottom"
                                                        overlay={<Tooltipp className="mytooltip">{it.assignee}</Tooltipp>}
                                                      >
                                                        <div className="boardAvatar">
                                                          <UserProfile user={it.user} />
                                                        </div>
                                                      </OverlayTrigger>
                                                    )
                                                  }
                                                </div>

                                                <div>
                                                  <PriorityIcon IconColor={it?.priority?.color} label={it?.priority?.name} />
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>)}</Draggable>
                                  )
                                })}
                              </InfiniteScroll>
                            {provided.placeholder}
                          </div>
                        </div>
                      </div>
                    )}
                  </Droppable>
                )
              })
              }
            </DragDropContext>
          </div>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withTranslation()(Board);
